import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "currencySymbol", "currencyName", "stripeAccount" ]

  connect() {
    this._updateCurrency(this.issuingAccount)
  }

  updateCurrency(event) {
    event.preventDefault()
    
    const selectedOption = event.target.selectedOptions[0]
    const issuingAccount = selectedOption.dataset.issuingAccount || selectedOption.value

    this._updateCurrency(issuingAccount)
  }

  _updateCurrency(value) {
    const currencySymbols = this.currencySymbolTargets;
    const currencyNames = this.currencyNameTargets;
    
    let symbol, name;
    
    switch (value) {
      case "StripeAPI::DE":
        symbol = "€";
        name = "EUR";
        break;
        
      case "StripeAPI::US":
        symbol = "$";
        name = "USD";
        break;
        
      case "StripeAPI::UK":
        symbol = "£";
        name = "GBP";
        break;
        
      default:
        symbol = "$";
        name = "USD";
        break;
    }
    
    currencySymbols.forEach(symbolTarget => {
      symbolTarget.innerText = symbol;
    });

    currencyNames.forEach(nameTarget => {
      nameTarget.innerText = name;
    });
  }

  
  get issuingAccount() {
    if (this.stripeAccountTarget.tagName === 'SELECT') {
      const selectedOption = this.stripeAccountTarget.selectedOptions[0]
      return selectedOption.dataset.issuingAccount || selectedOption.value
    } else {
      return this.stripeAccountTarget.value
    }
  }
}
